import React, { useCallback, useMemo, useRef } from 'react'

//* HOCs
import { withUserContext, withUIContext } from 'context'

//! Helpers
import { objectToFormData, countries } from 'helpers'

//* Components
import { ButtonSimple, FormContainer, Input, Select, SingleUpload, Icon } from 'components/common'

const EditProfile = ({ profile, tags, editProfile, btnLoading, ...props }) => {
    const form = useRef()
    const btnRef = useRef()

    const initialValues = useMemo(() => {
        return {
            ...profile,
            avatar: profile.avatar?.url,
            skills: profile.skills?.map((skill) => skill.id),
            interests: profile.interests?.map((interest) => interest.id),
        }
    }, [profile])

    const onFinish = useCallback((values) => {
        const formData = objectToFormData(values)
        return editProfile(formData)
    }, [])

    return (
        <FormContainer ref={form} initialValues={initialValues} onFinish={onFinish} className='edit-form'>
            <div className={'flexBoxColumn'}>
                <SingleUpload form={form} name={'avatar'} defaultUrl={profile.avatar?.url} errorKey={'Avatar'} />
                <div className='halfInputs flexBox'>
                    <Input label={'Name'} name={'name'} placeholder={'Name'} />
                    <Input label={'Surname'} name={'surname'} placeholder={'Surname'} />
                </div>
                <Input
                    type={'textarea'}
                    label={'Biography'}
                    name={'bio'}
                    placeholder={'Type something about you'}
                    required={false}
                    inputOptions={{
                        showCount: true,
                        maxLength: 1000,
                    }} />
                <Select
                    label={'Topics of interest'}
                    name={'interests'}
                    list={tags.interests}
                    mode={'multiple'}
                    required={false}
                    showSearch={true}
                />
                <div className='halfInputs flexBox location-select'>
                    <Select
                        label={'Location'}
                        name={['location', 'country']}
                        list={countries}
                        required={false}
                        placeholder={'Country'}
                        dropdownClassName='location-dropdown'
                        showSearch={true}
                    />
                    <Input
                        label={'Location'}
                        className='hideLabel'
                        name={['location', 'city']}
                        placeholder={'City'}
                        required={false}
                    />
                </div>
                <div className='halfInputs flexBox'>
                    <Input label={'Education'} name={['education', 'university']} placeholder={'University'} required={false} />
                    <Input label={'Education'} className='hideLabel' name={['education', 'major']} placeholder={'Major'} required={false} />
                </div>
                <div className='halfInputs flexBox'>
                    <Input label={'Work'} name={['work', 'company']} placeholder={'Company'} required={false} />
                    <Input label={'Work'} name={['work', 'position']} className='hideLabel' placeholder={'Position'} required={false} />
                </div>
                <Select
                    label={'Skills'}
                    name={'skills'}
                    list={tags.skills}
                    mode={'multiple'}
                    required={false}
                    showSearch={true} />
                <div className='social-link'>
                    <div className='cont flexBox'>
                        <Icon className='op-facebook grey' />
                        <Input
                            label={'Links to SM and professional accounts'}
                            name={['socials', 'facebook']}
                            placeholder={'Paste link to Facebook account'}
                            required={false}
                            rules={[{ type: 'url', message: 'Facebook URL must be a valid URL' }]}
                        />
                    </div>
                    <div className='cont flexBox'>
                        <Icon className='op-linkedin grey' />
                        <Input
                            name={['socials', 'linkedin']}
                            placeholder={'Paste link to Linkedin account'}
                            required={false}
                            rules={[{ type: 'url', message: 'LinkedIn URL must be a valid URL' }]}
                        />
                    </div>
                    <div className='cont flexBox'>
                        <Icon className='op-twitter grey' />
                        <Input
                            name={['socials', 'twitter']}
                            placeholder={'Paste link to Twitter account'}
                            required={false}
                            rules={[{ type: 'url', message: 'Twitter URL must be a valid URL' }]}
                        />
                    </div>
                    <div className='cont flexBox'>
                        <Icon className='op-instagram grey' />
                        <Input
                            name={['socials', 'instagram']}
                            placeholder={'Paste link to Instagram account'}
                            required={false}
                            rules={[{ type: 'url', message: 'Instagram URL must be a valid URL' }]}
                        />
                    </div>
                </div>
            </div>
            <div className='buttons flexBox spaceBetween alignEnd'>
                <ButtonSimple ref={btnRef} savedBtn={btnLoading} className='save-btn' submit text={`${btnRef.current > 0 ? 'Saved' : 'Save'}`} />
                <ButtonSimple onClick={props.toggleDeactivatePopup} className='red' text={`Deactivate profile`} />
            </div>
        </FormContainer>
    )
}

export default withUIContext(withUserContext(EditProfile, ['editProfile']), ['btnLoading', 'toggleDeactivatePopup'])
